import { Ride } from '../types/content';

export const rides: Ride[] = [
  {
    id: 'forest-walk',
    group: 'calm',
    route: 'forest',
    durationMin: 60,
    price: 45,
    title: { en: 'Forest walk', ru: 'Прогулка по лесу', et: 'Metsajalutus' },
    level: { en: 'Beginner', ru: 'Новичок', et: 'Algaja' },
    description: {
      en: 'Walk only, the guide stays close.',
      ru: 'Только шагом, инструктор рядом.',
      et: 'Ainult sammul, juhendaja on lähedal.',
    },
  },
  {
    id: 'arabian-trail',
    group: 'calm',
    route: 'forest',
    durationMin: 90,
    price: 60,
    title: { en: 'Arabian horse trail ride', ru: 'Прогулка на арабских лошадях', et: 'Araabia hobustega matk' },
    level: { en: 'Beginner – intermediate', ru: 'Новичок – средний', et: 'Algaja – kesktase' },
    description: {
      en: 'Forest paths and meadows on our Arabian horses.',
      ru: 'Лесные тропы и луга на наших арабских лошадях.',
      et: 'Metsarajad ja niidud meie araabia hobustega.',
    },
  },
  {
    id: 'sea-ride',
    group: 'calm',
    route: 'sea',
    durationMin: 120,
    price: 75,
    title: { en: 'Ride to the sea', ru: 'Прогулка к морю', et: 'Matk mere äärde' },
    level: { en: 'No experience needed', ru: 'Можно без опыта', et: 'Kogemust pole vaja' },
    description: {
      en: 'Through forest and dunes to the beach at a calm pace.',
      ru: 'Через лес и дюны к пляжу в спокойном темпе.',
      et: 'Läbi metsa ja luidete randa rahulikus tempos.',
    },
  },
  {
    id: 'sea-forest-long',
    group: 'advanced',
    route: 'sea',
    durationMin: 180,
    price: 100,
    title: { en: 'Big forest & sea ride', ru: 'Большой маршрут: лес и море', et: 'Suur metsa- ja merematk' },
    level: { en: 'Advanced', ru: 'Опытный', et: 'Edasijõudnu' },
    description: {
      en: 'Trot in the forest, canter along the waterline.',
      ru: 'Рысь по лесу, галоп вдоль воды.',
      et: 'Traav metsas, galopp veepiiril.',
    },
  },
  {
    id: 'romantic-two',
    group: 'calm',
    route: 'sea',
    durationMin: 120,
    price: 150,
    groupSize: 2,
    title: { en: 'Romantic ride for two', ru: 'Романтическая прогулка вдвоём', et: 'Romantiline matk kahele' },
    level: { en: 'Any level', ru: 'Любой уровень', et: 'Igale tasemele' },
    description: {
      en: 'Private — just the two of you and the guide.',
      ru: 'Только вы вдвоём и инструктор, без посторонних.',
      et: 'Privaatne — ainult teie kahekesi ja juhendaja.',
    },
  },
];
